import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TextInput from "./TextInput";
import CustomButton from "./CustomButton";
import SuccessAlert from "./sucessalert";

const SignUp = ({ open, setOpen }) => {
 const [isRegister, setIsRegister] = useState(true);
 const [accountType, setAccountType] = useState("seeker");
 const [check, setCheck] = useState('');
 const [errMsg, setErrMsg] = useState("");
 const [popupMsg, setPopupMsg] = useState("");
 const [popupColor, setPopupColor] = useState("");

 const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
 } = useForm({
    mode: "onChange",
 });

 const onSubmit = async (data) => {
  try {
    let endpoint = "";
    if (isRegister) {
      endpoint = accountType === "seeker" ? "/auth/register" : "/company/register";
    } else {
      endpoint = accountType === "seeker" ? "/auth/login" : "/company/login";
    }
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    if (!response.ok) {
      throw new Error(responseData.message || "Authentication failed!");
    }
    // Handle success
    localStorage.setItem('token', responseData.token);
    localStorage.setItem('isLogin', true);
    localStorage.setItem('role', accountType);
    setCheck(endpoint.includes('register') ? 'User Registered Successfully' : 'User Logged In Successfully');
    setPopupMsg(true);
    setErrMsg(false);
  } catch (error) {
    // Handle error
    setPopupMsg(error.message || "Something went wrong!");
    setPopupColor("bg-red-500");
  }};

 return (
    <div className='flex min-h-full items-center justify-center p-4 text-center'>
      <div className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
        <h3 className='text-xl font-semibold lwading-6 text-gray-900'>
          {isRegister ? "Create Account" : "Account Sign In"}
        </h3>

        <div className='w-full flex items-center justify-center py-4'>
          <button
            className={`flex-1 px-4 py-2 rounded text-sm outline-none ${
              accountType === "seeker"
                ? "bg-[#1d4fd862] text-blue-900 font-semibold"
                : "bg-white border border-blue-400"
            }`}
            onClick={() => setAccountType("seeker")}
          >
            User Account
          </button>
          <button
            className={`flex-1 px-4 py-2 rounded text-sm outline-none ${
              accountType !== "seeker"
                ? "bg-[#1d4fd862] text-blue-900 font-semibold"
                : "bg-white border border-blue-400"
            }`}
            onClick={() => setAccountType("company")}
          >
            Company Account
          </button>
        </div>

        <form className='w-full flex flex-col gap-5' onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            name='email'
            label='Email Address'
            placeholder='email@example.com'
            type='email'
            register={register("email", { required: "Email Address is required!" })}
            error={errors.email ? errors.email.message : ""}
          />

          {isRegister && (
            <div className='w-full flex gap-1 md:gap-2'>
              <div className={`${accountType === "seeker" ? "w-1/2" : "w-full"}`}>
                <TextInput
                 name={accountType === "seeker" ? "firstName" : "name"}
                 label={accountType === "seeker" ? "First Name" : "Company Name"}
                 placeholder={accountType === "seeker" ? "eg. James" : "Company name"}
                 type='text'
                 register={register(accountType === "seeker" ? "firstName" : "name", {
                    required: accountType === "seeker" ? "First Name is required" : "Company Name is required",
                 })}
                 error={accountType === "seeker" ? errors.firstName ? errors.firstName.message : "" : errors.name ? errors.name.message : ""}
                />
              </div>

              {accountType === "seeker" && isRegister && (
                <div className='w-1/2'>
                 <TextInput
                    name='lastName'
                    label='Last Name'
                    placeholder='Wagonner'
                    type='text'
                    register={register("lastName", { required: "Last Name is required" })}
                    error={errors.lastName ? errors.lastName.message : ""}
                 />
                </div>
              )}
            </div>
          )}

          <div className='w-full flex gap-1 md:gap-2'>
            <div className={`${isRegister ? "w-1/2" : "w-full"}`}>
              <TextInput
                name='password'
                label='Password'
                placeholder='Password'
                type='password'
                register={register("password", { required: "Password is required!" })}
                error={errors.password ? errors.password.message : ""}
              />
            </div>

            {isRegister && (
              <div className='w-1/2'>
                <TextInput
                 label='Confirm Password'
                 placeholder='Password'
                 type='password'
                 register={register("cPassword", {
                    validate: (value) => {
                      const { password } = getValues();
                      if (password !== value) {
                        return "Passwords do not match";
                      }
                    },
                 })}
                 error={errors.cPassword && errors.cPassword.type === "validate" ? errors.cPassword.message : ""}
                />
              </div>
            )}
          </div>

          {errMsg && (
            <span role='alert' className='text-sm text-red-500 mt-0.5'>
              {errMsg}
            </span>
          )}

          {popupMsg && (
            <div className={`text-white px-4 py-2 ${popupColor} rounded mt-2`}>
              {popupMsg}
            </div>
          )}

          <div className='mt-2'>
            <CustomButton
              type='submit'
              containerStyles={`inline-flex justify-center rounded-md bg-blue-600 px-8 py-2 text-sm font-medium text-white outline-none hover:bg-blue-800`}
              title={isRegister ? "Create Account" : "Login Account"}
            />
          </div>
        </form>

        <div className='mt-4'>
          <p className='text-sm text-gray-700'>
            {isRegister ? "Already have an account?" : "Do not have an account"}
            <span
              className='text-xl text-blue-600 ml-2 hover:text-blue-700 hover:font-semibold cursor-pointer'
              onClick={() => setIsRegister((prev) => !prev)}
            >
              {isRegister ? "Login" : "Create Account"}
            </span>
          </p>
        </div>
      </div>
      {check && (
        <SuccessAlert title={check} text='Thank you for using the Job Finder system' 
        link={window.location.href ="/"}/>
      )}
    </div>
 );
};

export default SignUp;
